import React from 'react';
import { MatchScheme } from '../../../../model/interfaces';
import styles from './finishedTournamentScheme.module.scss';

export default function TreeBlock(props: {
  matchResults: MatchScheme[][];
  title?: string;
}) {
  return (
    <>
      {props.title && <h2>{props.title}</h2>}
      <div className={styles.match}>
        {props.matchResults.map((stage, i) => (
          <ul key={i}>
            {stage.map((match, i) => (
              <React.Fragment key={i}>
                <Player
                  className={!match['1'] ? styles.noAfter : undefined}
                  loser={match['L']}
                >
                  {match['0']}
                </Player>
                <Player 
                  className={!match['1'] ? styles.noAfter : undefined}
                  loser={match['L']}
                >
                  {match['1']}
                </Player>
              </React.Fragment>
            ))}
          </ul>
        ))}
      </div>
    </>
  );
}

function Player(props: { className?: string; loser?: string; children?: string }) {
  if (!props.children) return null;
  return (
    <li
      className={props.className}
      style={{ color: props.loser === props.children ? 'gray' : 'white' }}
    >
      <span>{props.children}</span>
    </li>
  );
}
